module.exports = __webpack_public_path__ + "static/img/plan_category_room_build.5a898d20.png";